// Libs
import { createAsyncThunk } from '@reduxjs/toolkit';
// Others
import activityApi from '~/apis/activity';
import { CREATE_CALL_HISTORY, GET_ACTIVITY_LIST } from '~/utils/constants/actionType';
import { IBodyCreateCallHistory, IQueryParamActivity } from '~/utils/interface/activity';

export const getActivityList = createAsyncThunk(
  GET_ACTIVITY_LIST,
  async (params: IQueryParamActivity, { rejectWithValue }) => {
    try {
      const resp = await activityApi.getActivityList(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createCallHistory = createAsyncThunk(
  CREATE_CALL_HISTORY,
  async (body: IBodyCreateCallHistory, { rejectWithValue }) => {
    try {
      const resp = await activityApi.createCallHistory(body);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
